import { ApiError } from '@/api/client';
import { serverErrorsOf } from '@/lib/formErrors';
import { notAvailableYet } from '@/lib/mutationError';

/** What a form shows after a failed save; absent keys mean "leave as it is". */
export interface SaveFailure {
  server?: Record<string, string>;
  problem?: unknown;
  toast?: { title: string; description?: string };
}

/** Maps a failed project save onto the form: 501 → not-available problem, 412 → "changed since", else the server's field messages (or the problem when none is named). */
export function generalFailure(err: unknown): SaveFailure {
  const unavailable = notAvailableYet(err);
  if (unavailable) return { problem: unavailable };
  if (err instanceof ApiError && err.status === 412) return { problem: new ApiError(412, err.code, 'This project changed since the page loaded. It was reloaded: review the values and save again.', err.requestId) };
  const mapped = serverErrorsOf(err, 'name');
  const failure: SaveFailure = { server: mapped.fields, toast: mapped.toast };
  if (Object.keys(mapped.fields).length === 0) failure.problem = mapped.form ? new Error(mapped.form) : err;
  return failure;
}
